var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.color[_vm.status],"small":""}},[_vm._v("\n  "+_vm._s(_vm.status)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }